import { render, staticRenderFns } from "./ModalOrderForm.vue?vue&type=template&id=67814240&scoped=true"
import script from "./ModalOrderForm.vue?vue&type=script&lang=js"
export * from "./ModalOrderForm.vue?vue&type=script&lang=js"
import style0 from "./ModalOrderForm.vue?vue&type=style&index=0&id=67814240&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67814240",
  null
  
)

export default component.exports